const GOOGLEBOT_USER_AGENT = /googlebot/i

/**
 * Check if the request is coming from Googlebot
 * @param userAgent - user's browser userAgent
 */
export const isGooglebot = (userAgent: string): boolean =>
  GOOGLEBOT_USER_AGENT.test(userAgent ?? '')
